

































































































import Vue from 'vue';
import { BUTTON } from '@/constants/label';
import CtrlNormalBtn from '@/components/common/control/CtrlNormalBtn.vue';
import { Color, OutStatus, TorikomiResult, SumiFlg } from '@/constants/constants';
import { dateStrToNum } from '@/utils/utils';
import CtrlMessageDialog from '../common/control/CtrlMessageDialog.vue';

export default Vue.extend<any, any, any, any>({
  name: 'G_060_ShukkaJunbi_ChildHeaderInput',
  components: {
    CtrlNormalBtn,
    CtrlMessageDialog,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    childItem: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    BUTTON,
    Color,
    TorikomiResult,
    SumiFlg,
    items: [],
    headers: [
      {
        text: '№',
        value: 'renban',
        sortable: true,
        width: 50,
        class: 'text-end',
        cellClass: 'text-end',
      },
      {
        text: '品目',
        value: 'himmoku',
        class: 'text-truncate',
        cellClass: 'text-truncate',
        sortable: true,
        width: 350,
      },
      {
        text: '単位',
        value: 'tani',
        sortable: true,
        width: 65,
      },
      {
        text: '入数',
        value: 'irisu',
        sortable: true,
        width: 65,
        cellClass: 'text-end',
      },
      {
        text: 'c/s数量',
        value: 'suryo',
        sortable: true,
        width: 90,
        class: 'text-end',
        cellClass: 'text-end',
      },
      {
        text: 'バラ数量',
        value: 'hasu',
        sortable: true,
        width: 95,
        class: 'text-end',
        cellClass: 'text-end',
      },
      {
        text: '重量',
        value: 'juryo',
        sortable: true,
        width: 100,
        class: 'text-end',
        cellClass: 'text-end',
      },
      {
        text: '年産',
        value: 'nensan',
        sortable: true,
        width: 75,
        class: 'text-end',
        cellClass: 'text-end',
      },
      {
        text: '賞味期限',
        value: 'shomiKigenYmd',
        sortable: true,
        width: 100,
      },
      {
        text: '状態',
        value: 'jotai',
        sortable: true,
        width: 100,
      },
    ],
    footerProps: {},
    options: {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [],
    },
    messageShow: false,
    messageId: '',
    messageTextParam: [],
    isReload: false,
  }),
  computed: {},
  methods: {
    hide(reload = true) {
      this.$emit('update:show', false);
      this.$emit('hide', reload);
    },
    handleOkMessage() {
      this.messageShow = false;
      this.messageId = '';
      this.messageTextParam = [];
      this.hide(this.isReload);
    },
    async getData() {
      this.$store.dispatch('common/setIsLoading', true);
      const {
        orderNo,
        shukkaYoteiYmd,
        nohinYoteiYmd,
        shukkaJigyoshoCd,
        shukkaSokoCd,
        haisoKb,
        haisoTehaiKb,
        tokuisakiCd,
        nohinsakiCd,
        nyukoJigyoshoCd,
        nyukoSokoCd,
        haisoKaishaCd,
        nyuryokuSumiFlg,
        juchuEntryJigyoshoCd,
        juchuEntryYmd,
        juchuNo,
        hatchuIraiJigyoshoCd,
        hatchuIraiEntryYmd,
        hatchuIraiNo,
        idoIraiJigyoshoCd,
        idoIraiEntryYmd,
        idoIraiNo,
        hatchuJigyoshoCd,
        hatchuEntryYmd,
        hatchuNo,
      } = this.childItem;

      const params = {
        orderNo,
        shukkaYoteiYmd: dateStrToNum(shukkaYoteiYmd),
        nohinYoteiYmd: dateStrToNum(nohinYoteiYmd),
        shukkaJigyoshoCd,
        shukkaSokoCd,
        haisoKb,
        haisoTehaiKb,
        tokuisakiCd,
        nohinsakiCd,
        nyukoJigyoshoCd,
        nyukoSokoCd,
        haisoKaishaCd,
        nyuryokuSumiFlg,
        juchuEntryJigyoshoCd,
        juchuEntryYmd: dateStrToNum(juchuEntryYmd),
        juchuNo,
        hatchuIraiJigyoshoCd,
        hatchuIraiEntryYmd: dateStrToNum(hatchuIraiEntryYmd),
        hatchuIraiNo,
        idoIraiJigyoshoCd,
        idoIraiEntryYmd: dateStrToNum(idoIraiEntryYmd),
        idoIraiNo,
        hatchuJigyoshoCd,
        hatchuEntryYmd: dateStrToNum(hatchuEntryYmd),
        hatchuNo,
      };

      const res = await this.$store.dispatch('g060/getUchiwake', params);
      this.$store.dispatch('common/setIsLoading', false);

      if (
        res &&
        res.status == 200 &&
        res.data &&
        res.data.error &&
        res.data.error.messageID &&
        res.data.error.outStatus &&
        res.data.error.outStatus != OutStatus.NORMAL
      ) {
        this.messageId = res.data.error.messageID;
        this.messageTextParam = res.data.error.messageArgs;
        this.messageShow = true;
        this.isReload = true;
        return;
      }

      this.items = res.data.responseData ? res.data.responseData : [];
    },
  },
  created() {
    this.getData();
  },
});
